import * as React from "react";
import { Header, Button } from "semantic-ui-react";
import RecordCard from "./RecordCard";
import UploadCard from "./UploadCard";

type TlgQaColumnProps = {
  tlgQa: State.ColumnState;
  isUploading: boolean;
  uploadError: string | null;
  isPushing: boolean;
  onUpload: (jsonContent: string) => void;
  onPushToProd: () => void;
};

class TlgQaColumn extends React.Component<TlgQaColumnProps> {
  render(): JSX.Element {
    const { tlgQa, isUploading, uploadError, isPushing, onUpload, onPushToProd } = this.props;

    return (
      <div>
        <Header as="h3" dividing>
          TLG QA
        </Header>
        <UploadCard
          isUploading={isUploading}
          uploadError={uploadError}
          onUpload={onUpload}
        />
        <RecordCard
          record={tlgQa.record}
          viewJson={tlgQa.viewJson}
          isFetching={tlgQa.isFetching}
          fetchError={tlgQa.fetchError}
          title="Current QA Record"
        />
        {tlgQa.record && (
          <Button
            primary
            fluid
            loading={isPushing}
            disabled={isPushing}
            onClick={onPushToProd}
            style={{ marginTop: "1em" }}
          >
            Push to Prod
          </Button>
        )}
      </div>
    );
  }
}

export default TlgQaColumn;
